var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1237 4.93325L8.00108 7.05659L5.87708 4.93259C5.81357 4.87048 5.72816 4.83587 5.63934 4.83624C5.55051 4.83662 5.4654 4.87195 5.40241 4.93459L4.93575 5.40192C4.9038 5.43256 4.87833 5.46931 4.86085 5.50998C4.84337 5.55065 4.83424 5.59442 4.83399 5.63869C4.83374 5.68296 4.84238 5.72682 4.8594 5.76769C4.87643 5.80855 4.90148 5.84558 4.93308 5.87658L7.05641 7.99925L4.93375 10.1233C4.87173 10.1868 4.83724 10.2723 4.83774 10.3611C4.83824 10.45 4.87368 10.535 4.93641 10.5979L5.40308 11.0646C5.54041 11.2026 5.74708 11.1979 5.87775 11.0673L8.00175 8.94392L10.1244 11.0673C10.188 11.1293 10.2735 11.1638 10.3623 11.1633C10.4511 11.1628 10.5362 11.1273 10.5991 11.0646L11.0664 10.5979C11.0983 10.5672 11.1237 10.5304 11.1412 10.4898C11.1586 10.4491 11.1676 10.4053 11.1678 10.361C11.168 10.3167 11.1593 10.2729 11.1422 10.232C11.1252 10.1912 11.1001 10.1542 11.0684 10.1233L8.94441 7.99925L11.0684 5.87658C11.1305 5.81308 11.1651 5.72767 11.1648 5.63884C11.1644 5.55001 11.1291 5.4649 11.0664 5.40192L10.5997 4.93525C10.5685 4.90323 10.5312 4.87773 10.49 4.86023C10.4488 4.84272 10.4045 4.83355 10.3597 4.83325C10.3159 4.83361 10.2725 4.84263 10.2321 4.85979C10.1917 4.87695 10.1551 4.90191 10.1244 4.93325H10.1237Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchClose);
export default __webpack_public_path__ + "static/media/searchClose.4b9333eef32e914d98fdccab83eee4a8.svg";
export { ForwardRef as ReactComponent };